import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { EmailVerificationStatus, useAutoLoginMutation } from '@blockpulse3/graphql/hooks';

import { useUser } from '../../providers';

type Props = unknown;

export function AutoLogin(): JSX.Element {
  const { loadUser } = useUser();
  const [autoLoginMutation, { loading }] = useAutoLoginMutation();

  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  useEffect(() => {
    if (token && !loading) {
      autoLoginMutation({
        variables: {
          autoLoginInput: {
            token: token || '',
          },
        },
        onCompleted: (data) => {
          if (data?.autoLogin?.access_token) {
            localStorage.setItem('token', data.autoLogin.access_token);
            loadUser();
          } else if (
            data?.autoLogin?.process_step === EmailVerificationStatus.REDIRECT &&
            data?.autoLogin?.redirect_url
          ) {
            window.location.href = data?.autoLogin?.redirect_url;
          }
        },
        onError: (err) => {
          console.log(err);
        },
      });
    }
  }, [token, autoLoginMutation, loading, loadUser]);

  return <></>;
}

export type AutoLoginProps = Props;
